import React, { useState, useReducer, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import { config, timeConverter, formatMoney, resolveNotificationMessage } from '../helpers/constants';
import Service from "../services/service";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { IconButton, Accordion, AccordionSummary, AccordionDetails, Tooltip, Switch, FormGroup, Select, FormControlLabel, FormHelperText, Paper, Grid, Box, Typography, InputLabel, FormControl, Button, Tab, Tabs, AppBar, Dialog, List, DialogActions, DialogContent, DialogTitle, ListItem, TextField, MenuItem } from "@material-ui/core";
import IconLabel from './IconLabel';
import LoadingScreen from "./LoadingScreen";
import RevokeOrderForm from "./RevokeOrderForm";


export default function OrderList(props) {

    const useStyles = makeStyles((theme) => ({
        root: {
            position: "relative",
            width: "100%",
            height: "100%"
        },
        fullWidth: {
            width: "100%",
            marginBottom: theme.spacing(1)
        },
    }));

    const state = useContext(AppContext);
    const s = state.strings;
    const dispatch = useContext(DispatchContext);
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [revokeFormOrderId, setRevokeFormOrderId] = useState(null);

    useEffect(() => {
        setLoading(true);
        Service.getOrders().then((res) => {
            setLoading(false);
            dispatch(actions.setOrders(res.data.orders));
        });
    }, []);

    const onDownloadInvoiceClicked = (id) => {
        const url = config.backendUrl + "export/?rid=" + id;
        window.open(url, "_blank");
    }

    const onPayButtonClicked = (id) => {
        dispatch(actions.setCheckoutDetails({ paymentStep: 4, invoiceId: id, paymentStatus: "canceled", paid: false }));
        dispatch(actions.setUI( { profileDialogVisible: false, paymentDialogVisible: true }));
    }

    const onCancelOrderClicked = (orderId) => {
        dispatch(actions.openConfirmationDialog({
            title: s.orderList.cancelOrderConfirmTitle,
            text: s.orderList.cancelOrderConfirmText,
            onConfirm: () => {
                Service.cancelOrder(orderId).then((res) => {
                    if (res.success) {
                        dispatch(actions.openToast({ type: "success", message: s.notificationMessage.orderCancelSuccess, status: true }));
                        setLoading(true);
                        Service.getOrders().then((ordersRes) => {
                            setLoading(false);
                            dispatch(actions.setOrders(ordersRes.data.orders));
                        });
                    } else {
                        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage), status: true }));
                    }
                });
            }
        }));
    }

    const onRevokeOrderClicked = (order, invoiceId) => {
        if (!order.usageNotStarted) {
            dispatch(actions.openConfirmationDialog({
                title: s.orderList.revokeOrderUsageStartedTitle,
                text: s.orderList.revokeOrderUsageStarted,
            }));
            return;
        }
        setRevokeFormOrderId(order.id);
    }

    if (!loading && state.user.orders.length == 0) {
        return (
            <IconLabel centered label={s.userDialog.noOrders} />
        );
    }

    return (
        <div className={classes.root}>
            <LoadingScreen status={loading} />
            <RevokeOrderForm
                open={revokeFormOrderId !== null}
                onClose={() => setRevokeFormOrderId(null)}
                prefillOrderId={revokeFormOrderId}
            />
            {state.user.orders.map((order) => {
                const dateString = timeConverter(order.date, true, s.common.dateFormat);
                const productString = order.product ? order.product.nameShort : s.common.na;
                const hasUnpaidInvoices = order.invoices.some(inv => inv.payDate == null && inv.stornoDate == null);
                const allCancelled = !order.invoices.some(inv => inv.stornoDate == null);
                if (allCancelled) {
                    return null;
                }

                return (
                    <Accordion defaultExpanded={hasUnpaidInvoices} style={{ backgroundColor: '#EEEEEE', marginRight: 8 }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                        >
                            <Typography color="primary">{s.orderList.orderTitle.format(order.id, dateString, productString)} </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div style={{ display: "flex", width: "100%", flexDirection: "column" }}>
                                {/* Order status row */}
                                <div style={{ display: "flex", alignItems: "center", width: "100%", paddingTop: 8, paddingBottom: 8, borderBottom: "1px solid #cccccc", marginBottom: 4 }}>
                                    <div style={{ flex: "1 1 auto" }}>
                                        <Typography variant="body2" color="textSecondary">
                                            {s.orderList.orderStatus}: {
                                                (order.revokeConfirmedDate) ? s.orderList.statusRevoked :
                                                (order.revokeRequestedDate && !order.revokeConfirmedDate) ? s.orderList.statusRevokeRequested :
                                                order.invoices.every(inv => inv.stornoDate) ? s.orderList.statusCancelled :
                                                order.invoices.some(inv => inv.payDate && !inv.stornoDate) ? s.orderList.statusPaid :
                                                s.orderList.statusPending
                                            }
                                        </Typography>
                                    </div>
                                    <div style={{ flex: "0 0 auto", display: "flex", gap: 8 }}>
                                        {order.canRevoke && order.invoices.some(inv => inv.payDate && !inv.stornoDate) &&
                                            <Button onClick={() => onRevokeOrderClicked(order, order.invoices.find(inv => inv.payDate && !inv.stornoDate)?.id)} variant="outlined" style={{ width: 140 }}>{s.orderList.revokeOrder}</Button>
                                        }
                                        {!order.invoices.some(inv => inv.payDate) && order.invoices.some(inv => !inv.payDate && !inv.stornoDate) &&
                                            <Button onClick={() => onCancelOrderClicked(order.id)} variant="outlined" style={{ width: 140 }}>{s.orderList.cancelOrder}</Button>
                                        }
                                    </div>
                                </div>
                                {order.invoices.map((invoice) => {
                                    const invoiceDate = timeConverter(invoice.date, true, s.common.dateFormat);
                                    return (
                                        <div style={{ display: "flex", alignItems: "center", width: "100%", paddingTop: 8, backgroundColor: '#EEEEEE', borderTop: "1px solid white" }}>
                                            <div style={{ flex: "1 1 auto" }}>
                                                {s.orderList.invoiceTitle.format(invoice.id, invoiceDate, formatMoney(invoice.amount), invoice.currency)}
                                            </div>
                                            <div style={{ flex: "0 0 auto" }}>
                                                <IconButton onClick={() => onDownloadInvoiceClicked(invoice.id)}><CloudDownloadIcon /></IconButton>
                                            </div>
                                            <div style={{ flex: "0 0 auto" }}>
                                                {invoice.payDate ?
                                                    <Button disabled variant="contained" style={{ width: 140, backgroundColor: '#009900', color: 'white' }}>{order.revokeConfirmedDate ? s.notificationMessage.refunded : s.userDialog.paid}</Button>
                                                    : invoice.stornoDate ?
                                                        <Button disabled variant="outlined" style={{ width: 140 }}>{s.userDialog.orderCanceled}</Button>
                                                        :
                                                        <Button onClick={() => onPayButtonClicked(invoice.id)} variant="contained" style={{ width: 140, backgroundColor: '#BB0000', color: 'white' }}>{s.userDialog.payNow}</Button>
                                                }
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </div>
    );
}